import { SVGProps } from 'react'

const TimerIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width='15' height='14' viewBox='0 0 15 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <g clipPath='url(#clip0_354_185087)'>
                <path
                    d='M3.41602 12.8335H11.5827'
                    stroke='#959699'
                    strokeWidth='1.16667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M3.41699 1.1665H11.5837'
                    stroke='#959699'
                    strokeWidth='1.16667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M10.4163 12.8333V10.3997C10.4163 10.0903 10.2933 9.79357 10.0745 9.57483L7.49967 7L4.92484 9.57483C4.70603 9.79357 4.58307 10.0903 4.58301 10.3997V12.8333'
                    stroke='#959699'
                    strokeWidth='1.16667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4.58398 1.1665V3.60017C4.58405 3.90956 4.70701 4.20626 4.92582 4.425L7.50065 6.99984L10.0755 4.425C10.2943 4.20626 10.4173 3.90956 10.4173 3.60017V1.1665'
                    stroke='#959699'
                    strokeWidth='1.16667'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_354_185087'>
                    <rect width='14' height='14' fill='white' transform='translate(0.5)' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default TimerIcon
